import React from 'react';
import ReactDOM from 'react-dom/client';
import './lib/css/index.css';
import App from './App.jsx';
import ContextProvider from './lib/Context.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ContextProvider>
      <App />
    </ContextProvider>
  </React.StrictMode>
);
